import { render, staticRenderFns } from "./customerAllot.vue?vue&type=template&id=56883cea&scoped=true&"
import script from "./customerAllot.vue?vue&type=script&lang=js&"
export * from "./customerAllot.vue?vue&type=script&lang=js&"
import style0 from "./customerAllot.vue?vue&type=style&index=0&id=56883cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56883cea",
  null
  
)

export default component.exports